import { formatDateOnly } from '../../../../utils/dateUtils';

export const getCustomerStatementHistoryColumns = (th) => [
    { field: 'id', header: th('customerDefinition.history.id'), sortable: true },
    { field: 'chassisNo', header: th('customerDefinition.history.chassisNo'), sortable: true },
    { field: 'licensePlate', header: th('customerDefinition.history.licensePlate'), sortable: true },
    { field: 'customerName', header: th('customerDefinition.history.customerName'), sortable: true },
    { field: 'customerPhone', header: th('customerDefinition.history.customerPhone'), sortable: true },
    { field: 'customerStatement', header: th('customerDefinition.history.customerStatement'), sortable: true },
    { field: 'kmInformation', header: th('customerDefinition.history.kmInformation'), sortable: true },
    { field: 'brand', header: th('customerDefinition.history.brand'), sortable: true },
    { field: 'model', header: th('customerDefinition.history.model'), sortable: true },
    { field: 'engineNumber', header: th('customerDefinition.history.engineNumber'), sortable: true },
    {
        field: 'vehicleAcceptDate',
        header: th('customerDefinition.history.vehicleAcceptDate'),
        body: (rowData) => formatDateOnly(rowData?.vehicleAcceptDate),
        sortable: true
    },
    {
        field: 'dateOfTraffic',
        header: th('customerDefinition.history.dateOfTraffic'),
        body: (rowData) => formatDateOnly(rowData?.dateOfTraffic),
        sortable: true
    },
    { field: 'receivingDeliveryPerson', header: th('customerDefinition.history.receivingDeliveryPerson'), sortable: true },
    { field: 'receivingPerson', header: th('customerDefinition.history.receivingPerson'), sortable: true },
    { field: 'bosBranchCode', header: th('customerDefinition.history.bosBranchCode'), sortable: true },
    { field: 'bosBranchSiteCode', header: th('customerDefinition.history.bosBranchSiteCode'), sortable: true },
    {
        field: 'createdDate',
        header: th('customerDefinition.history.createdDate'),
        body: (rowData) => formatDateOnly(rowData?.createdDate),
        sortable: true
    },
    {
        field: 'modifiedDate',
        header: th('customerDefinition.history.modifiedDate'),
        body: (rowData) => formatDateOnly(rowData?.modifiedDate),
        sortable: true
    },
    { field: 'createdName', header: th('customerDefinition.history.createdName'), sortable: true },
    { field: 'modifiedName', header: th('customerDefinition.history.modifiedName'), sortable: true }
];